import { api } from "@/utils/axios";

interface IMyVisitorListsBody {
  page: number;
  pagesize: number;
}

export const visitorService = {
  myVisitorLists(body: IMyVisitorListsBody) {
    return api.post<PageResponseData>("/Visitor/my_visitor_lists", body);
  },
  configInfo() {
    return api.post<ResponseData>("Visitor/config_info");
  },
  add(body: any) {
    return api.post<ResponseData>("Visitor/visitor_add", body);
  },
  myVisitorDetail(body: any) {
    return api.post<ResponseData>("Software/my_visitor_detail", body);
  },
  visitorLists(body: any) {
    return api.post<PageResponseData>("Visitor/visitor_lists", body);
  },
  visitorDetail(id: string) {
    return api.post<ResponseData>("Visitor/visitor_detail", { id });
  },
  visitorOpt(body: any) {
    return api.post<ResponseData>("Visitor/visitor_opt", body);
  },
  visitorTargetLists(body = {}) {
    return api.post<PageResponseData>("Visitor/visitor_target_lists", body);
  },
  my_visitor_info(body: any) {
    return api.post<ResponseData>("Software/my_visitor_info", body);
  },
  my_visitor_perfect(body: any) {
    return api.post<ResponseData>("Software/my_visitor_perfect", body);
  },
  my_pass_new(body: any) {
    return api.post<ResponseData>("Visitor/my_pass_new", body);
  },
  my_visitor_detail(body: any) {
    return api.post<ResponseData>("Visitor/my_visitor_detail", body);
  },
  open_door(body: any) {
    return api.post<ResponseData>("Visitor/open_door", body);
  },
  related_face_lists() {
    return api.post<ResponseData>("Visitor/related_face_lists");
  },
  config_info() {
    return api.post<ResponseData>("Visitor/config_info");
  },
  related_face_del(body: any) {
    return api.post<ResponseData>("Visitor/related_face_del", body);
  },
  related_face_modify(body: any) {
    return api.post<ResponseData>("Visitor/related_face_modify", body);
  }
};
